export default "__VITE_ASSET__Q16Vkb8dkkryFQ2D0QY57w__"